<template>
  <button class="compact-button" @click="click">
    <slot />
  </button>
</template>

<script>
export default {
  name: 'CompactButton',
  methods: {
    click ($event) {
      this.$emit('click', $event)
    }
  }
}
</script>
<style lang="scss" scoped>
.compact-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $bionic-grey-300;
  border: 1px solid #e5e5e5;
  width: 40px;
  height: 42px;
  color: $button-text;
  border-radius: 6px;
  outline: 0 !important;
  transition: -webkit-transform 0.2s ease-out;

  @media (min-width: 720px) {
    width: 56px;
    height: 56px;
  }

  &:hover {
    transform: translate3d(0, -4px, 0);
  }
}
</style>
